export default __webpack_public_path__ + "static/media/iq.49a9a4bf.svg";